import {
	Box,
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	FormControlLabel,
	InputLabel,
	Radio,
	RadioGroup,
	TextField,
} from "@mui/material";
import React, { useEffect, useMemo, useState, useRef, useContext } from "react";
import { useTranslation } from "react-i18next";
import LabeledCheckbox from "../TemplateProperties/TPCheckbox";
import WorkflowSessionModal1 from "./WorkflowSessionModal1";
import WorkflowSessionModal2 from "./WorkflowSessionModal2";
import DatePattern from "./PatternModal/DatePattern";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../redux/api";
import { lgDocPath } from "../../constants/languageDocPaths";
import SmartPasswordField from "../../commonComponents/SmartPasswordField";
import { ParentScreenCtx } from "../../pages/workbench_build/WorkbenchBuild";
import { treeActions } from "../../redux/slices/treeSlice";

const WorkflowSessionModal = ({
	openModal,
	setModalOpen,
	handleClose,
	initialValue,
	valuesHandler,
	showWorkflowSession,
	showCallingWorkflow,
	showAccountData,
	showDateAndTime,
	showSystemData,
	valueLabel,
	inputType = 'text',
	specialPasswordField,
	initialMaskLength
}) => {
	const { t } = useTranslation();
	const queryParams = useSelector((state) => state.queryParams);
	const [checked, setChecked] = useState("");
	const [value, setValue] = useState("");
	const [datePattern, setDatePattern] = useState("");
	const [valid, setValid] = useState(true);
	const [loading, setLoading] = useState(false);
	const [dpNetworkCallMessage, setDpNetworkCallMessage] = useState("");
	const dispatch = useDispatch();
	const [modalStates, setModalStates] = useState({
		openModal: false,
		type: 0
	});
	const [cursorPosition, setCursorPosition] = useState(0);
	const textFieldRef = useRef(null);
	const currentScreen = useSelector(state => state?.treeData?.currentScreen);
	const { leftTree, templateChanged } = useSelector(state => state?.treeData?.[currentScreen || "workflow"] || {});
	const rightTreeSelectedNode = useSelector((state) => state.treeData?.workflow?.rightTree?.tree?.[state.treeData?.workflow?.rightTree?.currentTab]?.selectedNode);

	const options = useMemo(() => {
		const optionsArray = [];
		if (showWorkflowSession) optionsArray.push("BTN_ADD_VALUE_FROM_WFSESSION")
		if (showCallingWorkflow) optionsArray.push("BTN_ADD_VALUE_FROM_CALLINGWORKFLOW")
		if (showAccountData) optionsArray.push("BTN_ADD_VALUE_FROM_ACCOUNT_DATA")
		if (showDateAndTime) optionsArray.push("BTN_ADD_DATE_TIME_STAMP")
		if (showSystemData) optionsArray.push("BTN_SYSTEM_DATA")
		
		setChecked(optionsArray?.[0] || "")
		return optionsArray.map((e, i) => {
			return <FormControlLabel
				key={"wfsmoptions-" + i}
				value={e}
				control={<Radio />}
				label={t(e)}
			/>
		})

	}, [showAccountData, showCallingWorkflow, showCallingWorkflow, showWorkflowSession, showSystemData])

	const handleClose2 = (value = false, isOpenModal) => {
		setModalStates((prev) => {
			return {
				openModal: value,
				type: prev.type,
			};
		});
		setChecked(modalStates.type);
		if (isOpenModal) setModalOpen({ open: true, isFirstTime: false });
	};

	const valueHandler = (values = [], previousValue, isFinishClicked) => {
		let finalString = "";
		if(values) {
			values?.forEach((value => {
				const valuesArray = Object.keys(value)?.filter((o) => ["MAPNAME", "WF_ITEM_LOCATION", "WF_ITEM_ID", "type"].includes(o));
				if(valuesArray.length)finalString = finalString + "%";
				valuesArray.forEach((o, i) => {
					if (value[o])
					finalString += value[o] + (valuesArray.length - 1 === i ? "" : ",");
				});
				if(valuesArray.length)finalString = finalString + "%";
			}))
		}
		
		const prevValue = previousValue || "";
		finalString = prevValue.substring(0, cursorPosition) + finalString + prevValue.substring(cursorPosition);
		setValue(finalString);
		if (isFinishClicked) {
			valuesHandler(finalString);
		}
	};

	const handleTextFieldChange = (e) => {
		setValue(e.target.value);
		setCursorPosition(e.target.selectionStart || 0);
	};

	const handleTextFieldClick = (e) => {
		setCursorPosition(e.target.selectionStart || 0);
	};

	const handleTextFieldSelect = (e) => {
		setCursorPosition(e.target.selectionStart || 0);
	};

	const testDateHandler = (key, val) => {
		if (!val) {
			setDpNetworkCallMessage(
				t(
					"BOX_NO_FORMAT_WAS_SPECIFIED__SEL_CANCEL_TO_CLS_DIALOG_AND_RET_TO_MAIN_SCREEN"
				)
			);
			setValid(false);
		}
		if (val) {
			setLoading(true);
			dispatch(
				api.endpoints.validateDatePattern.initiate({
					datePattern: encodeURIComponent(val),
				})
			)
				.then((response) => {
					if (response) {
						if (response.data.current_state === "ERROR") {
							setValid(false);
							setDpNetworkCallMessage(response.data.message);
						} else {
							if (key === "fromModal") {
								const msg = response.data.message.split("\n");
								const responseMsg = msg[1];
								setDpNetworkCallMessage(responseMsg || response?.data?.message);
							}
							setValid(true);
						}
					}
				})
				.finally(() => {
					setLoading(false);
				});
		}
	};

	useEffect(() => {
		if (openModal.open && openModal.isFirstTime) {
			setValue(initialValue || "");
			setCursorPosition(0);
		}
	}, [initialValue, openModal.open]);

	useEffect(() => {
		if (templateChanged) {
		  dispatch(
			treeActions.setLeftTreeContextActionValue({
			  screen: "workflow",
			  data: {
				name: leftTree.tree.body.selectedNode.title,
				workflowGroup: leftTree.tree.body.selectedNode.workflowGroup,
			  },
			})
		  );
		}
	  }, [rightTreeSelectedNode?.key]);

	return (
		<>
			<Dialog
				open={openModal.open || false}
				fullWidth
				maxWidth='sm'
				sx={{ overflow: "hidden" }}
			>
				<DialogTitle className='dialog-header'>
					<div className='title'>
						{" "}
						{t("DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD2_TIT")}{" "}
					</div>
					<div className='description'>
						{" "}
						{t("DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD2_DESC")}{" "}
					</div>
				</DialogTitle>
				<DialogContent
					sx={{ overflow: "auto", width: "100%", padding: "0 !important" }}
					className='modal-content'
					dividers
				>
					<Box padding={"20px"} className='dialog-header'>
						<div
							style={{
								marginBottom: "1rem",
								fontSize: "15px",
								textAlign: "justify",
							}}
						>
							{t("DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD2_MSG")}
						</div>
						<Box
							sx={{
								height: "100%",
								overflowX: "hidden",
								maxHeight: "400px",
								margin: "auto",
								borderRadius: "0.2rem",
								fontSize: "1.2rem",
								display: "grid",
								gap: "px",
								overflow: "hidden",
								margin: "1rem  0 2rem 0",
							}}
						>
							<RadioGroup
								aria-labelledby='demo-controlled-radio-buttons-group'
								name='controlled-radio-buttons-group'
								value={checked}
								onChange={(e) => setChecked(e.target.value)}
							>
								{options}
							</RadioGroup>
						</Box>

						<Box>
							{(specialPasswordField && openModal.open) ? (
								<SmartPasswordField
									variant='outlined'
									size='small'
									label={valueLabel}
									className={"width-100"}
									name={"TITLE"}
									value={value}
									onChange={handleTextFieldChange}
									onClick={handleTextFieldClick}
									onSelect={handleTextFieldSelect}
									inputRef={textFieldRef}
									initialMaskLength={initialMaskLength}

								/>
							) : (
								<FormControl className='width-100' size='small'>
									<TextField
										variant='outlined'
										size='small'
										label={valueLabel}
										type={inputType || 'text'}
										className={"width-100"}
										name={"TITLE"}
										value={value}
										onChange={handleTextFieldChange}
										onClick={handleTextFieldClick}
										onSelect={handleTextFieldSelect}
										inputRef={textFieldRef}
									/>
								</FormControl>
							)}
						</Box>
					</Box>
				</DialogContent>
				<DialogActions>
					<Button
						size='small'
						variant='outlined'
						color='primary'
						onClick={() => {
							setModalStates({
								openModal: true,
								type: checked,
							});
							handleClose();
						}}
					>
						{" "}
						{t("BTN_NEXT")}
					</Button>
					<Button
						size='small'
						variant='outlined'
						color='primary'
						onClick={() => {
							valuesHandler(value);
							handleClose();
						}}
					>
						{" "}
						{t("BTN_FINISH")}
					</Button>
					<Button
						size='small'
						variant='outlined'
						color='primary'
						onClick={() => {
							handleClose(false);
							setValue("");
						}}
					>
						{" "}
						{t("BTN_CANCEL")}
					</Button>
				</DialogActions>
			</Dialog>
			<WorkflowSessionModal1
				inputType={inputType}
				handleTextFieldClick={handleTextFieldClick}
				previousValue={value}
				showSelection={"true"}
				valueHandler={valueHandler}
				handleClose={handleClose2}
				openModal={modalStates.openModal && modalStates.type === "BTN_ADD_VALUE_FROM_CALLINGWORKFLOW"}
				sourceType='callingWorkflow'
				specialPasswordField={specialPasswordField}
				initialMaskLength={initialMaskLength}
			/>
			<WorkflowSessionModal2
				inputType={inputType}
				handleTextFieldClick={handleTextFieldClick}
				previousValue={value}
				showSelection={"true"}
				sourceType='accountData'
				openModal={modalStates.openModal && modalStates.type === "BTN_ADD_VALUE_FROM_ACCOUNT_DATA"}
				handleClose2={handleClose2}
				handleClose1={() => {}}
				resetStates={() => {}}
				valueHandler={valueHandler}
				specialPasswordField={specialPasswordField}
				initialMaskLength={initialMaskLength}
			/>
			<WorkflowSessionModal2
				handleTextFieldClick={handleTextFieldClick}
				previousValue={value}
				showSelection={"true"}
				sourceType='workflowSession'
				openModal={modalStates.openModal && modalStates.type === "BTN_ADD_VALUE_FROM_WFSESSION"}
				handleClose2={handleClose2}
				handleClose1={() => {}}
				resetStates={() => {}}
				valueHandler={valueHandler}
				specialPasswordField={specialPasswordField}
				initialMaskLength={initialMaskLength}
			/>
			<WorkflowSessionModal2
				handleTextFieldClick={handleTextFieldClick}
				previousValue={value}
				showSelection={"true"}
				sourceType='systemData'
				openModal={modalStates.openModal && modalStates.type === "BTN_SYSTEM_DATA"}
				handleClose2={handleClose2}
				handleClose1={() => {}}
				resetStates={() => {}}
				valueHandler={valueHandler}
				specialPasswordField={specialPasswordField}
				initialMaskLength={initialMaskLength}
			/>

			<DatePattern
				sourceType='sessionWorkflowModal'
				openModal={modalStates.openModal && modalStates.type === "BTN_ADD_DATE_TIME_STAMP"}
				docPath={`${queryParams.baseUrl}/docs/${
					lgDocPath[queryParams.lang] || "en"
				}/Workbench/dialogs/DateFormatter.html`}
				okHandler={(isFinishClicked) => {
					const dateString = `%TODAY,${datePattern}%`;
					const newValue = value.substring(0, cursorPosition) + dateString + value.substring(cursorPosition);
					setValue(newValue);
					if (isFinishClicked) valuesHandler(newValue);
					setDatePattern("");
					setDpNetworkCallMessage("");
					handleClose2(false, true);
				}}
				handleClose={handleClose}
				onChangeHandler={setDatePattern}
				datePattern={datePattern}
				cancelHandler={() => handleClose2(false, true)}
				testDateHandler={testDateHandler}
				dpNetworkCallMessage={dpNetworkCallMessage}
				valid={valid}
				loading={loading}
			/>
		</>
	);
};

export default WorkflowSessionModal;
